module.exports = __webpack_public_path__ + "img/video_directory_setup.24e15931.svg";